<template>
  <div class="myprize-overlay">
    <div class="myprize-modal">
      <!-- 背景图 -->
<!--      <div class="myprize-bg">-->
<!--        <img src="../assets/prize/bg.png" alt="background" class="bg-img">-->
<!--      </div>-->

      <!-- 奖品内容区 -->
      <div class="myprize-content">

        <!-- 一等奖 -->
        <div v-if="prizeLevel === 1" class="prize-display">
          <div class="prize-img-wrap">
            <img src="../assets/myprize/bg.png" alt="一等奖" class="prize-img">
            <div class="info">
              <img src="../assets/myprize/1.png" alt="">
            </div>
          </div>
        </div>

        <!-- 二等奖 -->
        <div v-else-if="prizeLevel === 2" class="prize-display">
          <div class="prize-img-wrap">
            <img src="../assets/myprize/bg.png" alt="二等奖" class="prize-img">
            <div class="info">
              <img src="../assets/myprize/2.png" alt="">
            </div>
          </div>
        </div>

        <!-- 三等奖 -->
        <div v-else-if="prizeLevel === 3" class="prize-display">
          <div class="prize-img-wrap">
            <img src="../assets/myprize/bg.png" alt="三等奖" class="prize-img">
            <div class="info">
              <img src="../assets/myprize/3.png" alt="">
            </div>
          </div>
        </div>

        <!-- 未中奖提示参与游戏 -->
        <div  class="prize-display no-prize" v-if="isOver ===1 && !prizeLevel">
          <div class="no-prize-img-wrap">
            <img src="../assets/myprize/nom.png" alt="未中奖" class="no-prize-img">
          </div>
        </div>
        <!-- 本次活动未中奖 -->
        <div  class="prize-display no-prize" v-if="isOver ===2 && !prizeLevel">
          <div class="no-prize-img-wrap">
            <img src="../assets/myprize/fail.png" alt="未中奖" class="no-prize-img">
          </div>
        </div>

        <!-- 兑换码区域 -->
        <div class="code-section" v-if="code">
          <span class="code-txt">兑换码</span>
          <span class="code-text">{{ code }}</span>
          <button class="copy-btn" @click="copyCode">
            {{copyText}}
          </button>
        </div>
      </div>

      <!-- 关闭按钮 -->
      <div class="myprize-close" @click="handleClose">
        <img src="../assets/btn/close.png" alt="关闭">
      </div>
    </div>
  </div>
</template>

<script>
import {reqUserInfo} from "../api";

export default {
  name: 'MyPrize',
  props: {
    // 奖品等级：1-一等奖, 2-二等奖, 3-三等奖, 0-未中奖
    level: {
      type: Object,
    }
  },
  data() {
    return {
      prizeLevel: this.level.type,
      code: this.level.code,
      copyText:"复制",
      isOver:0
    }
  },
  watch: {

  },
  mounted() {
    reqUserInfo().then(res => {

    //  res.data.treasureCount<4  res.data.drawCount   1次机会
    //  res.data.drawCount || res.data.shareCount >0 //机会

      // this.isOver  =1; 引导参与游戏
      // this.isOver  =2; 所有机会都没有
    //
    // if(res.data.treasureCount<4)  // this.isOver  =1;
    // if(res.data.drawCount>0)  // this.isOver  =1;
    // if(res.data.shareCount>0)  // this.isOver =1;

      if(res.data.treasureCount>=4 && res.data.drawCount<=0 && res.data.shareCount<=0){
        this.isOver =2;
      }else{
        this.isOver  =1;
      }



      // if( !res.data.prizeId || !res.data.shareCount || !res.data.drawCount){
      //   this.isOver  =1;
      // }else{
      //   this.isOver  =2;
      // }

    })
  },
  methods: {

    handleClose() {
      this.$emit('close')
    },
    copyCode() {
      // 优先使用 clipboard API（需要 HTTPS），否则降级到 execCommand
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(this.code).then(() => {
          this.copyText = '已复制'
          setTimeout(() => { this.copyText = '复制' }, 2000)
        }).catch(() => {
          this.fallbackCopy()
        })
      } else {
        this.fallbackCopy()
      }
    },
    fallbackCopy() {
      const textarea = document.createElement('textarea')
      textarea.value = this.code
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.copyText = '已复制'
      setTimeout(() => { this.copyText = '复制' }, 2000)
    },
  }
}
</script>

<style scoped>
.myprize-overlay {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.myprize-modal {
  width: 85%;
  max-width: 340px;
  position: relative;
}

.myprize-bg {
  width: 100%;
}

.myprize-bg .bg-img {
  width: 100%;
  display: block;
}

.myprize-content {
  width: 100%;
  height: 100%;
}

.prize-display {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: prizeFadeIn 0.5s ease-out;
}

@keyframes prizeFadeIn {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }
  70% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.prize-img-wrap {
  width: 100%;
  text-align: center;
  position: relative;
}
.prize-img-wrap .info{
  position: absolute; width: 100%; height: 100%; top:20%; left: 0;
  pointer-events: none;
}
.prize-img-wrap .info img{
  width: 55%;
}
.prize-img-wrap .prize-img {
  width: 100%;
  height: auto;
  pointer-events: painted;
}

.no-prize-img-wrap {
  width: 100%;
  text-align: center;
}

.no-prize-img-wrap .no-prize-img {
  width: 100%;
  height: auto;
}

/* 关闭按钮 */
.myprize-close {
  position: absolute;
  bottom: -8%;
  text-align: center;
  width: 100%;
  animation: prizeFadeIn 0.5s ease-out;
}

.myprize-close img {
  width: 14%;
}

/* 兑换码区域 */
.code-section {
  position: absolute;
  bottom: 10%;
  left: 0;
  width: 105%;
  padding: 0 15%;
  box-sizing: border-box;
  text-align: left;

}

.code-text {
  font-size: .8rem;
  font-weight: bold;
  color: #333;
  letter-spacing:1px;
  background: #f5f5f5;
  padding: 3px 12px;
  border-radius: 30px;
  margin-right: 10px;

}
.code-txt{
  color: #333;
  font-size: .7rem;
  margin-right: 2%;
}
.copy-btn {
  background: #c75421;
  color: #fff;
  border: none;
  padding: 3px 16px;
  border-radius: 30px;
  font-size: 0.75rem;
  cursor: pointer;
  white-space: nowrap;
}

.copy-btn:active {
  opacity: 0.8;
}

</style>



// WEBPACK FOOTER //
// src/components/MyPrize.vue